export default __webpack_public_path__ + "static/media/carousel9Mobile.0ff3516e.jpg";